import React from "react";
import type {VoidFunctionComponent} from "react";
import {useNotesPlayedDurationSwitcherLogic} from "./NotesPlayedDurationSwitcher.logic";
import {DurationSwitcher, IDurationSwitcherProps} from "../duration-switcher/DurationSwitcher";

export const NotesPlayedDurationSwitcher: VoidFunctionComponent = () => {
  const {selectedRange, changeSelectedRange} = useNotesPlayedDurationSwitcherLogic();
  return <DurationSwitcher {...{selectedRange, changeSelectedRange} as IDurationSwitcherProps} />;
}
